import { render } from "./ModuleHeaderTwoImages.vue?vue&type=template&id=2bbee625"
import script from "./ModuleHeaderTwoImages.vue?vue&type=script&lang=js"
export * from "./ModuleHeaderTwoImages.vue?vue&type=script&lang=js"

import "./ModuleHeaderTwoImages.vue?vue&type=style&index=0&id=2bbee625&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__